<ds-modal
  [modal]="modal"
  [title]="title"
  [maxWidthPercentage]="maxWidthPercentage"
  [closeAllModals]="closeAllModals"
  (modalClosed)="onCancel()"
>
  <ng-template ds-modal-header-actions>
    <button
      ds-button
      type="button"
      class="ds-action-confirmation-modal-close"
      data-test-id="ds-action-confirmation-modal-close"
      [variant]="DsButtonVariants.microActionHorizontalLayout"
      [microActionIcon]="Icons.XMark"
      (click)="onCancel()"
    >
      {{ closeLabel }}
    </button>
  </ng-template>

  <p class="mb-4" data-test-id="ds-action-confirmation-modal-message">
    {{ message }}
  </p>
  <div class="d-flex flex-row gap-3 justify-content-end">
    <button
      ds-button
      type="button"
      data-test-id="ds-action-confirmation-modal-cancel"
      [variant]="DsButtonVariants.secondary"
      (click)="onCancel()"
    >
      {{ cancelLabel }}
    </button>
    <button
      ds-button
      type="button"
      data-test-id="ds-action-confirmation-modal-confirm"
      [variant]="DsButtonVariants.primary"
      (click)="onConfirm()"
    >
      {{ confirmLabel }}
    </button>
  </div>
</ds-modal>
